import SplitHero from "../Generic/SplitHero";
import { isLoggedIn as checkLogin } from "../../utility/UserUtils";
import { useNavigate } from "react-router-dom";

const TrainingsHero = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkLogin();

  return (
    <SplitHero
      title="TRAININGS AT WISE"
      description="WISE Trainings prepare women to succeed in the semiconductor ecosystem through flexible, expert-led learning..."
      imageSrc="/assets/training/trainingherobg.svg"
      imagePosition="right"
      buttonText={!isLoggedIn ? "Join the WISE Training Community" : null}
      onButtonClick={() => navigate("/signup")}
      bgClass="bg-title"
      cardOffset="0%"
    />
  );
};

export default TrainingsHero;
